import { ICompositeDataBoundControlProperties } from '../entities/ICompositeDataBoundControlProperties';
import DataBoundControl from './DataBoundControl';
import { IDictionary } from '@bimser/core';
import { JSX } from 'react';

export default class CompositeDataBoundControl extends DataBoundControl {
	constructor() {
		super();
	}

	__loadProperties(data: ICompositeDataBoundControlProperties) {
		super.__loadProperties(data);
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData()
		};
	}

	__render(children?: React.ReactNode): JSX.Element {
		return super.__render(children);
	}
}
